import { NgModule }              from '@angular/core';
import { RouterModule, Routes }   from '@angular/router';
import { AiAnalystComponent }     from './ai-analyst.component';

const routes: Routes = [
	{ path: '', component: AiAnalystComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AiAnalystRoutingModule {
}
